export const statusOptions = [
  { value: "running", label: "Running", bgcolor: "#EAF7EF", color: "#2D7D46" },
  { value: "pending", label: "Pending", bgcolor: "#F8F3EA", color: "#A67C52" },
  { value: "closed", label: "Closed", bgcolor: "#F4F4F6", color: "#A0A0A0" },
];
